<template>
  <v-container>
    <h3>アラームメール送信先設定</h3>

    <div class="mt-8 mb-5">

      <v-row>
        <v-col cols="12">
          <h4 class="ms-1">送信先一覧</h4>
        </v-col>

        <v-divider class="mb-2"></v-divider>

        <v-col cols="12" v-if="mailingList.length == 0 && verifyingAddressList.length == 0">
          <p class="ms-3">未登録</p>
        </v-col>

        <v-col cols="12" v-for="(mailTo, index) in mailingList" v-bind:key="mailTo.mailAddress">
          <v-card variant="outlined">
            <v-card-item>
              <v-card-title class="text-subtitle-2" style="text-overflow: inherit; white-space: unset;">
                {{ mailTo.mailAddress }}
              </v-card-title>
            </v-card-item>

            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-label class="text-subtitle-2">対象チャンネル</v-label>
                </v-col>

                <v-col :cols="$vuetify.display.mobile ? 12 : 3" class="ps-3" v-if="hasAnalog1">
                  <v-switch color="primary" hide-details="true"
                    v-model="mailTo.isSubscribe.a1" :loading="mailTo.isToggleLoading.a1"
                    @update:modelValue="targetChannel = 'a1'; toggleSubscribeChannel(mailTo);">
                    <template v-slot:label>アナログ1</template>
                  </v-switch>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? 12 : 3" class="ps-3" v-if="hasAnalog2">
                  <v-switch color="primary" hide-details="true"
                    v-model="mailTo.isSubscribe.a2" :loading="mailTo.isToggleLoading.a2"
                    @update:modelValue="targetChannel = 'a2'; toggleSubscribeChannel(mailTo);">
                    <template v-slot:label>アナログ2</template>
                  </v-switch>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? 12 : 3" class="ps-3" v-if="hasAnalog3">
                  <v-switch color="primary" hide-details="true"
                    v-model="mailTo.isSubscribe.a3" :loading="mailTo.isToggleLoading.a3"
                    @update:modelValue="targetChannel = 'a3'; toggleSubscribeChannel(mailTo);">
                    <template v-slot:label>アナログ3</template>
                  </v-switch>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? 12 : 3" class="ps-3" v-if="hasAnalog4">
                  <v-switch color="primary" hide-details="true"
                    v-model="mailTo.isSubscribe.a4" :loading="mailTo.isToggleLoading.a4"
                    @update:modelValue="targetChannel = 'a4'; toggleSubscribeChannel(mailTo);">
                    <template v-slot:label>アナログ4</template>
                  </v-switch>
                </v-col>

                <v-col :cols="$vuetify.display.mobile ? 12 : 3" class="ps-3" v-if="hasDigitalInput1">
                  <v-switch color="primary" hide-details="true"
                    v-model="mailTo.isSubscribe.d1" :loading="mailTo.isToggleLoading.d1"
                    @update:modelValue="targetChannel = 'd1'; toggleSubscribeChannel(mailTo);">
                    <template v-slot:label>デジタル入力1</template>
                  </v-switch>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? 12 : 3" class="ps-3" v-if="hasDigitalInput2">
                  <v-switch color="primary" hide-details="true"
                    v-model="mailTo.isSubscribe.d2" :loading="mailTo.isToggleLoading.d2"
                    @update:modelValue="targetChannel = 'd2'; toggleSubscribeChannel(mailTo);">
                    <template v-slot:label>デジタル入力2</template>
                  </v-switch>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="d-flex justify-end">
              <v-btn icon="mdi-delete" size="small" color="error" :loading="mailTo.isDeleteLoading"
                v-on:click="targetIndex = index; isShowDeleteConfirmDialog = true;"></v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" v-for="verification in verifyingAddressList" v-bind:key="verification.mailAddress">
          <v-card variant="flat" style="border: 1px solid #00000040">
            <v-card-item>
              <v-card-title class="text-subtitle-2" style="text-overflow: inherit; white-space: unset; opacity: 75%;">
                {{ verification.mailAddress }}
              </v-card-title>
            </v-card-item>

            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-label class="text-subtitle-2">確認メールURL有効期限</v-label>
                </v-col>

                <v-col cols="12">
                  <p class="ma-1">{{ verification.expirationDatetime }}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn variant="outlined" prepend-icon="mdi-reload"
            :loading="isGetListLoading" v-on:click="getMailingList">
            再読み込み
          </v-btn>
        </v-col>
      </v-row>

      <v-form @submit.prevent ref="form" class="mt-9">
        <v-row>
          <v-col cols="12">
            <h4 class="ms-1">新規送信先</h4>
          </v-col>

          <v-divider class="mb-2"></v-divider>

          <v-col :cols="$vuetify.display.mobile ? 12 : 7" v-bind:class="{ 'px-6': !$vuetify.display.mobile }">
            <v-label class="mb-4">メールアドレス</v-label>
            <v-text-field density="compact" placeholder="email@example.com"
              :rules="[
                v => (!!v) || '必須',

                v => (v && ((v.match(/@/g) || []).length == 1)) || 'メールアドレスの形式が正しくありません',

                v => (v && !v.split('@')[0].startsWith('.')) || 'メールアドレスの形式が正しくありません',
                v => (v && !v.split('@')[0].endsWith('.')) || 'メールアドレスの形式が正しくありません',
                v => (v && (v.split('@')[0].indexOf('..') == -1)) || 'メールアドレスの形式が正しくありません',

                v => (v && !!v.split('@')[0].match(/^[a-zA-Z0-9\+\-_\.]+$/)) || 'メールアドレスの形式が正しくありません',

                v => (v && !!v.split('@')[1].match(/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+[a-zA-Z]{2,}$/)) || 'メールアドレスの形式が正しくありません'
              ]"
              persistent-hint hint="必須"
              v-model="address"></v-text-field>
          </v-col>

          <v-col cols="12" class="my-2" v-if="isShowLimitErrorMessage">
            <v-alert variant="tonal" type="error" v-model="isShowLimitErrorMessage" closable>
              アラームメール送信先は最大で10件までです
            </v-alert>
          </v-col>

          <v-col cols="12" class="my-2" v-if="isShowConflictMessage">
            <v-alert variant="tonal" type="error" v-model="isShowConflictMessage" closable>
              同一のアドレスが既に登録されています
            </v-alert>
          </v-col>

          <v-col cols="12" class="my-2" v-if="isShowAdditionCompleteMessage">
            <v-alert variant="tonal" type="success" v-model="isShowAdditionCompleteMessage" closable>
              入力されたアドレスに確認メールを送信しました
            </v-alert>
          </v-col>

          <v-col cols="12" class="d-flex justify-end">
            <v-btn elevation="0" color="primary" :loading="isPostLoading" v-on:click="postMailAddress">
              確認メール送信
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

    </div>

    <v-dialog max-width="400" v-model="isShowDeleteConfirmDialog">
      <v-card>
        <v-card-text>
          選択した送信先を削除します。よろしいですか？
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn v-on:click="isShowDeleteConfirmDialog = false;">
            キャンセル
          </v-btn>
          <v-btn color="error" v-on:click="isShowDeleteConfirmDialog = false; deleteMailAddress();">
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';

import axios from 'axios';

import config from '@/config.js';

export default defineComponent({
  name: 'AlarmMailToSetting',
  props: {
    moduleId: { type: String }
  },

  setup(props) {

    const hasAnalog1 = ref(false);
    const hasAnalog2 = ref(false);
    const hasAnalog3 = ref(false);
    const hasAnalog4 = ref(false);

    const hasDigitalInput1 = ref(false);
    const hasDigitalInput2 = ref(false);

    const mailingList = ref([]);

    const verifyingAddressList = ref([]);

    const isGetListLoading = ref(true);

    const targetIndex = ref(-1);
    const targetChannel = ref('');

    const form = ref();
    const address = ref('');

    const isShowLimitErrorMessage = ref(false);
    const isShowConflictMessage = ref(false);
    const isShowAdditionCompleteMessage = ref(false);

    const isPostLoading = ref(false);

    const isShowDeleteConfirmDialog = ref(false);


    onMounted(() => {

      fetchChannelList();

      getMailingList();

    });

    const fetchChannelList = () => {

      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/channels`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        hasAnalog1.value = ('a1' in response.data.channels);
        hasAnalog2.value = ('a2' in response.data.channels);
        hasAnalog3.value = ('a3' in response.data.channels);
        hasAnalog4.value = ('a4' in response.data.channels);

        hasDigitalInput1.value = ('d1' in response.data.channels);
        hasDigitalInput2.value = ('d2' in response.data.channels);

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const getMailingList = () => {

      mailingList.value = [];

      isGetListLoading.value = true;

      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/mailing-list`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        response.data.addressList.forEach((mailTo) => {

          mailTo.isSubscribe = {};

          mailTo.isSubscribe.a1 = mailTo.subscribeChannels.includes('a1');
          mailTo.isSubscribe.a2 = mailTo.subscribeChannels.includes('a2');
          mailTo.isSubscribe.a3 = mailTo.subscribeChannels.includes('a3');
          mailTo.isSubscribe.a4 = mailTo.subscribeChannels.includes('a4');

          mailTo.isSubscribe.d1 = mailTo.subscribeChannels.includes('d1');
          mailTo.isSubscribe.d2 = mailTo.subscribeChannels.includes('d2');


          mailTo.isToggleLoading = {};

          mailTo.isToggleLoading.a1 = false;
          mailTo.isToggleLoading.a2 = false;
          mailTo.isToggleLoading.a3 = false;
          mailTo.isToggleLoading.a4 = false;

          mailTo.isToggleLoading.d1 = false;
          mailTo.isToggleLoading.d2 = false;


          mailingList.value.push(mailTo);

        });

        verifyingAddressList.value = response.data.verifyingAddressList;

        isGetListLoading.value = false;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };


    const toggleSubscribeChannel = (mailTo) => {

      mailTo.isToggleLoading[targetChannel.value] = 'amber-darken-2';

      isShowLimitErrorMessage.value = false;
      isShowConflictMessage.value = false;
      isShowAdditionCompleteMessage.value = false;


      const reqBody = {
        mailAddress: mailTo.mailAddress,
        channel: targetChannel.value,
        isSubscribe: mailTo.isSubscribe[targetChannel.value]
      };

      axios.patch(
        config.API_URL +
        `/modules/${ props.moduleId }/mailing-list`,
        reqBody,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((/* response */) => {

        mailTo.isToggleLoading[targetChannel.value] = false;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const deleteMailAddress = () => {

      mailingList.value[targetIndex.value].isDeleteLoading = true;

      isShowLimitErrorMessage.value = false;
      isShowConflictMessage.value = false;
      isShowAdditionCompleteMessage.value = false;


      const reqBody = {
        mailAddress: mailingList.value[targetIndex.value].mailAddress
      };

      axios.delete(
        config.API_URL +
        `/modules/${ props.moduleId }/mailing-list`,
        {
          headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') },
          data: reqBody
        }
      ).then((/* response */) => {

        getMailingList();

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const postMailAddress = async () => {

      const { valid } = await form.value.validate();
      if (!valid) {
        return;
      }


      isShowLimitErrorMessage.value = false;
      isShowConflictMessage.value = false;
      isShowAdditionCompleteMessage.value = false;

      if (mailingList.value.length >= 10) {
        isShowLimitErrorMessage.value = true;
        return;
      }

      for (let i = 0; i < mailingList.value.length; i++) {
        if (mailingList.value[i].mailAddress === address.value) {
          isShowConflictMessage.value = true;
          return;
        }
      }


      isPostLoading.value = true;

      const reqBody = {
        mailAddress: address.value
      };

      axios.post(
        config.API_URL +
        `/modules/${ props.moduleId }/mailing-list`,
        reqBody,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((/* response */) => {

        address.value = '';
        form.value.resetValidation();

        getMailingList();

        isShowAdditionCompleteMessage.value = true;

        isPostLoading.value = false;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };


    return {
      hasAnalog1,
      hasAnalog2,
      hasAnalog3,
      hasAnalog4,

      hasDigitalInput1,
      hasDigitalInput2,

      mailingList,

      verifyingAddressList,

      isGetListLoading,

      targetIndex,
      targetChannel,

      form,
      address,

      isShowLimitErrorMessage,
      isShowConflictMessage,
      isShowAdditionCompleteMessage,

      isPostLoading,

      isShowDeleteConfirmDialog,

      getMailingList,

      toggleSubscribeChannel,
      deleteMailAddress,
      postMailAddress
    }

  }
});
</script>
